'use memo';

import { AgxColumn } from '@urbanx/agx-ui-components';
import { AgxSpacer } from '@urbanx/agx.ui-components2';
import { getEnumValue } from 'helpers/enumHelper';
import { Tabs } from 'types/Tabs';
import AgencyAgreementInfoPanel from './AgencyAgreement/AgencyAgreementInfoPanel';
import AgencyAgreementSubmissionInfoPanel from './AgencyAgreementSubmission/AgencyAgreementSubmissionInfoPanel';
import ListingsPanel from './Listing/ListingsPanel';
import './CampaignInfoPanel.scss';
import { useState, useEffect } from 'react';
import clsx from 'clsx';
import {
  CampaignDetailModel,
  CampaignDetailModelStage,
} from '@urbanx/agx.campaigns.client';

interface CampaignInfoPanelProps {
  campaign?: CampaignDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const CampaignInfoPanel = ({
  campaign,
  currentTab,
  mobile = false,
}: CampaignInfoPanelProps) => {
  const [visible, setVisible] = useState(false);
  const [currentCampaignId, setCurrentCampaignId] = useState<
    string | undefined
  >(campaign?.campaignId);

  const fadeIn = () => {
    setCurrentCampaignId(campaign?.campaignId);
    setVisible(false);

    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  };

  useEffect(() => {
    return fadeIn();
  }, []);

  useEffect(() => {
    if (currentCampaignId === campaign?.campaignId) return;

    return fadeIn();
  }, [campaign]);

  const { stage } = campaign ?? {};

  const enumStageValue = getEnumValue(
    CampaignDetailModelStage,
    stage ?? CampaignDetailModelStage.AgreementDraft
  );

  return (
    <AgxSpacer
      direction="vertical"
      className={clsx('campaignInfoPanel', visible && 'visible')}
      padding="lg"
      gap="md"
      contentJustification="start"
    >
      {campaign &&
        (enumStageValue === CampaignDetailModelStage.AgreementDraft ||
          enumStageValue === CampaignDetailModelStage.AgreementAgentSigning ||
          enumStageValue === CampaignDetailModelStage.AgreementVendorSigning ||
          enumStageValue ===
            CampaignDetailModelStage.AgreementSignedByAllParties) && (
          <AgencyAgreementInfoPanel
            currentTab={currentTab}
            campaign={campaign}
            mobile={mobile}
          />
        )}
      {campaign &&
        enumStageValue ===
          CampaignDetailModelStage.AgreementSubmissionIncomplete && (
          <AgencyAgreementSubmissionInfoPanel
            campaign={campaign}
            mobile={mobile}
            currentTab={currentTab}
          />
        )}
      {campaign &&
        (enumStageValue ===
          CampaignDetailModelStage.AgreementPendingCompliance ||
          enumStageValue === CampaignDetailModelStage.ListingCurrent ||
          enumStageValue === CampaignDetailModelStage.ListingUnderContract ||
          enumStageValue === CampaignDetailModelStage.ListingWithdrawn ||
          enumStageValue === CampaignDetailModelStage.ListingSold) && (
          <ListingsPanel
            campaign={campaign}
            mobile={mobile}
            currentTab={currentTab}
          />
        )}
    </AgxSpacer>
  );
};

export default CampaignInfoPanel;
